import React from "react";
import clsx from "clsx";
import { Destination } from "../../../../../../../../models/Entities";
import { Card, Text } from "@merge-api/merge-javascript-shared";

type DestinationButtonProps = {
  className?: string;
  destination: Destination;
  onClick: () => void;
};

const DestinationButton = ({ className, destination, onClick }: DestinationButtonProps) => {
  return (
    <Card
      type="button"
      onClick={onClick}
      className={clsx(
        "flex flex-col justify-start items-center pt-4 pb-6 w-full h-[100px] hover:opacity-60 transition-opacity duration-[120ms]",
        className,
      )}
    >
      <img className="flex w-[40px] h-[40px]" src={destination.image} />
      <Text variant="title-sm" className="mt-1 leading-4">
        {destination.name}
      </Text>
    </Card>
  );
};

export default DestinationButton;
